// extracted by mini-css-extract-plugin
export default {"form-change-password":"ForgotPassword_form-change-password__N7a48","button-change":"ForgotPassword_button-change__10iGq","loading":"ForgotPassword_loading__nhHH8"};